import { v4 as uuidv4 } from 'uuid';

export const addFakeEvent = (event, currentRetailerUser = {}, textAction = '') => {
  const agentName = `${currentRetailerUser.first_name} ${currentRetailerUser.last_name}`;

  let acction;
  let type_event;

  switch (event) {
    case 'assign_agent':
      type_event = 'assign_agent';
      acction = textAction;
      break;
    case 'not_assign':
      type_event = 'not_assign';
      acction = textAction;
      break;
    case 'change_status_chat':
      type_event = 'change_status_chat';
      acction = textAction;
      break;
    case 'create_note':
      type_event = 'create_note';
      acction = 'Nota creada';
      break;
    case 'create_order_note':
      type_event = 'create_order_note';
      acction = 'Nota de orden creada';
      break;
    case 'create_sale':
      type_event = 'create_sale';
      acction = 'Venta creada';
      break;
    case 'create_deal':
      type_event = 'create_deal';
      acction = 'Negociación creada';
      break;
    case 'create_reminder':
      type_event = 'create_reminder';
      acction = 'Mensaje programado creado';
      break;
    case 'unread_chat':
      type_event = 'unread_chat';
      acction = 'Chat marcado como no leído';
      break;
    case 'inactive_bot':
      type_event = 'inactive_bot';
      acction = 'Chatbot desactivado';
      break;
    default:
      acction = '';
  }

  if (!acction) return;

  return (dispatch) => {
    dispatch({
      type: 'ADD_NEW_FAKE_CUSTOMER_EVENT',
      payload: {
        id: uuidv4(),
        type_event: type_event,
        action: acction,
        agent_name: agentName,
        direction: 'internal'
      }
    });
  }
}